function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_36_195)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 0.5H3.99995C2.0702 0.5 0.5 2.0702 0.5 3.99995V17.9999C0.5 19.9296 2.0702 21.4998 3.99995 21.4998H17.9999C19.9296 21.4998 21.4998 19.9296 21.4998 17.9999V3.99995C21.4998 2.0702 19.9296 0.5 17.9999 0.5H18ZM20.1 18C20.1 19.1581 19.1581 20.1 18 20.1H3.99995C2.84195 20.1 1.89995 19.1581 1.89995 18V3.99995C1.89995 2.84195 2.84195 1.89995 3.99995 1.89995H17.9999C19.1579 1.89995 20.0999 2.84195 20.0999 3.99995V17.9999L20.1 18Z",
  fill: "#D1D1D1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 0.5H3.99995C2.0702 0.5 0.5 2.0702 0.5 3.99995V17.9999C0.5 19.9296 2.0702 21.4998 3.99995 21.4998H17.9999C19.9296 21.4998 21.4998 19.9296 21.4998 17.9999V3.99995C21.4998 2.0702 19.9296 0.5 17.9999 0.5H18ZM20.1 18C20.1 19.1581 19.1581 20.1 18 20.1H3.99995C2.84195 20.1 1.89995 19.1581 1.89995 18V3.99995C1.89995 2.84195 2.84195 1.89995 3.99995 1.89995H17.9999C19.1579 1.89995 20.0999 2.84195 20.0999 3.99995V17.9999L20.1 18Z",
  fill: "#D1D1D1",
  fillOpacity: 0.2
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_36_195"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 21,
  fill: "white",
  transform: "translate(0.5 0.5)"
})));

function SvgUnchecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.e7e12ddac677d54fdf4899e39a62b2613002c2d4e26fcc99110b1804dda64191.svg";
export { ForwardRef as ReactComponent };